module.exports = __webpack_public_path__ + "static/media/map_pin_unknown.66e4cd7e.svg";